import React, { useState } from "react";
import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import InputCustom from "../../../components/InputCustom";
import Button from "../../../components/Button";
import styles from "../../../styles/Configuracoes.module.scss";

const touched = { current_password: true, new_password: true, confirm_password: true };

export default function TabSenha({ form_senha, erros_senha, loading, onChange, onAlterar }) {
  const [mostrar_senha_atual, setMostrarSenhaAtual] = useState(false);
  const [mostrar_nova_senha, setMostrarNovaSenha] = useState(false);
  const [mostrar_confirmar_senha, setMostrarConfirmarSenha] = useState(false);

  return (
    <>
      <div className={styles.card}>
        <InputCustom
          label="Senha atual"
          name="current_password"
          type={mostrar_senha_atual ? "text" : "password"}
          value={form_senha.current_password}
          onChange={(e) => onChange("current_password", e.target.value)}
          disabled={loading}
          required
          errors={erros_senha}
          touched={touched}
          icon_left={
            <button
              type="button"
              className={styles.toggleSenha}
              onClick={() => setMostrarSenhaAtual((prev) => !prev)}
            >
              {mostrar_senha_atual ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
            </button>
          }
        />

        <InputCustom
          label="Nova senha"
          name="new_password"
          type={mostrar_nova_senha ? "text" : "password"}
          value={form_senha.new_password}
          onChange={(e) => onChange("new_password", e.target.value)}
          disabled={loading}
          required
          errors={erros_senha}
          touched={touched}
          icon_left={
            <button
              type="button"
              className={styles.toggleSenha}
              onClick={() => setMostrarNovaSenha((prev) => !prev)}
            >
              {mostrar_nova_senha ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
            </button>
          }
        />

        <InputCustom
          label="Confirme sua nova senha"
          name="confirm_password"
          type={mostrar_confirmar_senha ? "text" : "password"}
          value={form_senha.confirm_password}
          onChange={(e) => onChange("confirm_password", e.target.value)}
          disabled={loading}
          required
          errors={erros_senha}
          touched={touched}
          icon_left={
            <button
              type="button"
              className={styles.toggleSenha}
              onClick={() => setMostrarConfirmarSenha((prev) => !prev)}
            >
              {mostrar_confirmar_senha ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
            </button>
          }
        />
      </div>

      <div className={styles.botoesRodape}>
        <Button
          type="button"
          variant="primary"
          size="md"
          loading={loading}
          disabled={loading}
          onClick={onAlterar}
        >
          Alterar senha
        </Button>
      </div>
    </>
  );
}
